import { render } from "./user.vue?vue&type=template&id=131b7cbc&scoped=true"
const script = {}

import "./user.vue?vue&type=style&index=0&id=131b7cbc&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131b7cbc"]])

export default __exports__